import { getList } from '@/api/lottery.js';

const lottery = {
    state: {
        items: [],
        all:[]
    },
    mutations: {
        SET_LOTTERY_LIST: (state, data) => {
            state.items = data;
        },
        SET_LOTTERY_All: (state, data) => {
            state.all = data;
        }
    },
    actions: {
        getLotteryList({ commit, state }, num) {
            return new Promise((resolve, reject) => {
                getList().then(response => {
                    if (response.data.code == 200) {
                        let data = response.data.data;
                        let all_list = [];
                        for(let i=0; i < data.length; i++) {
                            for(let item of data[i].list) {
                                item.type_code = data[i].code;
                                all_list[item.loty] = item;
                            }
                        }
                        commit('SET_LOTTERY_LIST', data);
                        commit('SET_LOTTERY_All', all_list);
                    }                    
                    resolve(response);
                }).catch(err => {
                    reject(err);
                });
            });
        }
    }
};

export default lottery;


// WEBPACK FOOTER //
// ./src/store/modules/lottery.js